import { render, staticRenderFns } from "./AddChangeDelete.vue?vue&type=template&id=526af8c2&scoped=true"
import script from "./AddChangeDelete.vue?vue&type=script&lang=js"
export * from "./AddChangeDelete.vue?vue&type=script&lang=js"
import style0 from "./AddChangeDelete.vue?vue&type=style&index=0&id=526af8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526af8c2",
  null
  
)

export default component.exports